import * as t from 'io-ts';

export const integrationsPublicApiKeyCodec = t.type({
  public_api_key: t.string,
});
